import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from './storage'; // <- used our wrapper to define storage of indexedDB
// all reducers
import authReducer from './auth/authSlice';
import restaurantReducer from './restaurant/restaurantSlice';
import menuReducer from './menu/menuSlice';
import cartReducer from './cart/cartSlice';
import dealReducer from './deal/dealSlice';
import giftCardReducer from './giftCards/giftCardSlice';
import menuMetadataReducer from './menu/menuMetadataSlice';
import settingReducer from './settings/settingSlice';
import navigationReducer from './navigation/navigationSlice';

import deliveryReducer from './delivery/deliverySlice';
//rtk services
import { menuApi } from './menu/menuServices';
import { restaurantApi } from './restaurant/restaurantServices';
import { setupListeners } from '@reduxjs/toolkit/query';
import { cateringApi } from './catering/cateringServices';
import cateringSlice from './catering/cateringSlice';
import snackbarSlice from './snackbar/snackbarSlice';

// each slice gets its own key in IndexedDB
export const authPersistConfig = {
  key: 'auth',
  storage,
  version: 1,
};

const restaurantPersistConfig = {
  key: 'restaurant',
  storage,
  version: 1,
};

const menuPersistConfig = {
  key: 'menu',
  storage,
  version: 1,
};

export const cartPersistConfig = {
  key: 'cart',
  storage,
  version: 1,
};

const dealPersistConfig = {
  key: 'deal',
  storage,
  version: 1,
};

const giftCardPersistConfig = {
  key: 'giftCard',
  storage,
  version: 1,
};

const menuMetadataPersistConfig = {
  key: 'menuMetadata',
  storage,
  version: 1,
};
const settingsPersistConfig = {
  key: 'settings',
  storage,
  version: 1,
};
const cateringPersistConfig = {
  key: 'catering',
  storage,
  version: 1,
};

const navigationPersistConfig = {
  key: 'navigation',
  storage,
  version: 1,
};
const deliveryPersistConfig = {
  key: 'delivery',
  storage,
  version: 1,
};

const rootReducer = combineReducers({
  // all slices reducers use persistReducer if needed to persist
  auth: persistReducer(authPersistConfig, authReducer),
  restaurant: persistReducer(restaurantPersistConfig, restaurantReducer),
  menu: persistReducer(menuPersistConfig, menuReducer),
  cart: persistReducer(cartPersistConfig, cartReducer),
  deal: persistReducer(dealPersistConfig, dealReducer),
  giftCard: persistReducer(giftCardPersistConfig, giftCardReducer),
  menuMetadata: persistReducer(menuMetadataPersistConfig, menuMetadataReducer),
  settings: persistReducer(settingsPersistConfig, settingReducer),
  catering: persistReducer(cateringPersistConfig, cateringSlice),
  snackbar: snackbarSlice,
  navigation: persistReducer(navigationPersistConfig, navigationReducer),

  delivery: persistReducer(deliveryPersistConfig, deliveryReducer),
  // all rtk services reducers
  [menuApi.reducerPath]: menuApi.reducer,
  [restaurantApi.reducerPath]: restaurantApi.reducer,
  [cateringApi.reducerPath]: cateringApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // to avoid non-serializable value error for rtk-persist
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(menuApi.middleware, restaurantApi.middleware, cateringApi.middleware), // add rtk services middleware
});
setupListeners(store.dispatch);

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
